<template>
  <div class="page-container">
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">汇率列表</span>
        <div class="table-actions">
          <button v-auth="'payment:rateConfig:save'" class="btn btn-primary btn-sm" @click="openAddModal">+ 新增汇率</button>
          <button v-auth="'payment:rateConfig:find'" class="btn btn-secondary btn-sm" @click="fetchList">🔄 刷新</button>
        </div>
      </div>
      <el-table ref="table" :data="tableData" border v-loading="loading" style="width:100%;">
        <el-table-column prop="fromCurrency" label="来源币种" width="110">
          <template slot-scope="{row}">{{ row.fromCurrency || '--' }}</template>
        </el-table-column>
        <el-table-column prop="toCurrency" label="兑换币种" width="110">
          <template slot-scope="{row}">{{ row.toCurrency || '--' }}</template>
        </el-table-column>
        <el-table-column label="入金汇率" width="110" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtRate(row.depositRate) }}</span></template>
        </el-table-column>
        <el-table-column label="出金汇率" width="110" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtRate(row.withdrawRate) }}</span></template>
        </el-table-column>
        <el-table-column prop="decimalPlaces" label="汇率小数位" width="90" align="center"></el-table-column>
        <el-table-column prop="roundModeName" label="出金取舍方式" width="110">
          <template slot-scope="{row}">{{ row.roundModeName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="dataSourceName" label="数据源" width="100">
          <template slot-scope="{row}">{{ row.dataSourceName || '--' }}</template>
        </el-table-column>
        <el-table-column label="汇率类型" width="90">
          <template slot-scope="{row}">
            <el-tag :type="row.autoUpdate === 1 ? 'success' : 'info'" size="mini">{{ row.autoUpdateName || '--' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" width="100">
          <template slot-scope="{row}">{{ row.createUser || '--' }}</template>
        </el-table-column>
        <el-table-column prop="updateUser" label="最后更新人" width="110">
          <template slot-scope="{row}">{{ row.updateUser || '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
        </el-table-column>
        <el-table-column label="最后更新时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.updateDate) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="toggleStatus(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button v-auth="'payment:rateConfig:edit'" type="text" size="small" style="color:var(--brand-primary);" @click="openEditModal(row)">编辑</el-button>
            <el-button v-auth="'payment:rateConfig:delete'" type="text" size="small" style="color:#dc2626;" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="editVisible" width="600px" :close-on-click-modal="false" :title="editForm.id ? '编辑汇率' : '新增汇率'">
      <el-form :model="editForm" label-width="100px" size="small" :rules="editRules" ref="editForm">
        <el-form-item label="状态" prop="isDelete">
          <el-radio-group v-model="editForm.isDelete">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="汇率类型" prop="autoUpdate">
          <el-radio-group v-model="editForm.autoUpdate">
            <el-radio :label="1">自动</el-radio>
            <el-radio :label="2">固定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="来源币种" prop="fromCurrency">
          <el-select v-model="editForm.fromCurrency" style="width:100%;" placeholder="请选择来源币种">
            <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换币种" prop="toCurrency">
          <el-select v-model="editForm.toCurrency" style="width:100%;" placeholder="请选择兑换币种">
            <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入金汇率" prop="depositRate">
          <el-input-number v-model="editForm.depositRate" :min="0.0001" :precision="4" :step="0.0001" style="width:100%;" placeholder="请输入入金汇率"></el-input-number>
        </el-form-item>
        <el-form-item label="出金汇率" prop="withdrawRate">
          <el-input-number v-model="editForm.withdrawRate" :min="0.0001" :precision="4" :step="0.0001" style="width:100%;" placeholder="请输入出金汇率"></el-input-number>
        </el-form-item>
        <el-form-item label="出金取舍方式" prop="roundMode">
          <el-select v-model="editForm.roundMode" style="width:100%;">
            <el-option :value="1" label="四舍五入"></el-option>
            <el-option :value="2" label="向上取整"></el-option>
            <el-option :value="3" label="向下取整"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据源" prop="dataSource">
          <el-select v-model="editForm.dataSource" style="width:100%;">
            <el-option :value="1" label="手动"></el-option>
            <el-option :value="2" label="汇率API"></el-option>
            <el-option :value="3" label="系统默认"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇率小数位" prop="decimalPlaces">
          <el-input-number v-model="editForm.decimalPlaces" :min="0" :max="6" :precision="0" style="width:180px;"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button type="primary" @click="submitSave">{{ editForm.id ? '保存' : '确认' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { rateConfigList, rateConfigAddOrUpdate, rateConfigDelete, rateConfigStatus } from '@/api/rateConfig'

export default {
  name: 'RateConfigList',
  data() {
    return {
      tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15,
      currencies: ['CNY', 'USD', 'USDT-TRC', 'USDT'],
      editVisible: false,
      editForm: { id: null, isDelete: 1, autoUpdate: 1, fromCurrency: '', toCurrency: '', depositRate: null, withdrawRate: null, roundMode: 1, dataSource: 1, decimalPlaces: 2 },
      editRules: {
        fromCurrency: [{ required: true, message: '请选择来源币种', trigger: 'change' }],
        toCurrency: [{ required: true, message: '请选择兑换币种', trigger: 'change' }],
        depositRate: [{ required: true, message: '请输入入金汇率', trigger: 'blur' }],
        withdrawRate: [{ required: true, message: '请输入出金汇率', trigger: 'blur' }],
        roundMode: [{ required: true, message: '请选择出金取舍方式', trigger: 'change' }],
        dataSource: [{ required: true, message: '请选择数据源', trigger: 'change' }]
      }
    }
  },
  created() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      rateConfigList({ pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    fmtRate(v) { return v === null || v === undefined || v === '' ? '--' : Number(v) },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' },
    openAddModal() {
      this.editForm = { id: null, isDelete: 1, autoUpdate: 1, fromCurrency: '', toCurrency: '', depositRate: null, withdrawRate: null, roundMode: 1, dataSource: 1, decimalPlaces: 2 }
      this.editVisible = true
    },
    openEditModal(row) {
      this.editForm = {
        id: row.id,
        isDelete: row.isDelete,
        autoUpdate: row.autoUpdate,
        fromCurrency: row.fromCurrency,
        toCurrency: row.toCurrency,
        depositRate: Number(row.depositRate),
        withdrawRate: Number(row.withdrawRate),
        roundMode: row.roundMode,
        dataSource: row.dataSource,
        decimalPlaces: row.decimalPlaces || 2
      }
      this.editVisible = true
    },
    submitSave() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const f = this.editForm
        if (f.fromCurrency === f.toCurrency) { this.$message.warning('来源币种与兑换币种不能相同'); return }
        if (!(f.depositRate > 0)) { this.$message.warning('请输入有效的入金汇率'); return }
        if (!(f.withdrawRate > 0)) { this.$message.warning('请输入有效的出金汇率'); return }
        rateConfigAddOrUpdate(f).then(res => {
          if (res.code === 0) {
            this.$message.success(this.editForm.id ? '保存成功' : '新增成功')
            this.editVisible = false; this.fetchList()
          } else this.$message.error(res.message || '操作失败')
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除汇率配置「' + row.fromCurrency + ' → ' + row.toCurrency + '」？删除后不可恢复。', '删除确认', { type: 'warning' }).then(() => {
        rateConfigDelete(row.id).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchList() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    toggleStatus(row) {
      rateConfigStatus(row.id, row.isDelete).then(res => {
        if (res.code === 0) {
          this.$message.success(row.isDelete === 1 ? '已启用' : '已关闭')
          this.fetchList()
        } else this.$message.error(res.message || '操作失败')
      })
    }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.table-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500; font-family: inherit; cursor: pointer; transition: all 0.15s; border: 1px solid transparent; white-space: nowrap; }
.btn-primary { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.btn-secondary { background: transparent; color: #5a6578; border-color: #e8ecf2; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
.mono { font-family: 'JetBrains Mono', monospace; }
</style>
